























































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import UserQuestionForm from '../../../api/v2/forms/user_question'
import Simplemde from '../atoms_molecules/Simplemde.vue'
import { userState } from '../../stores/user'
import { checkMobile } from '../../utils/utils'
import { userQuestionState } from '../../stores/user_quetions'
import markdownParser from '../../../../helpers/markdown-parser'
import {ROUTER_NAME} from "../../router";

@Component({
  components: {
    Simplemde
  }
})
export default class UserQuestionFormView extends Vue {
  @Prop({ default: '' }) courseId: string
  @Prop({ default: '' }) lessonId: string
  // Formの動く状況
  @Prop({ default: false }) value: boolean


  get vModel(){
    return this.value
  }
  set vModel(value: boolean){
    this.$emit('input', value)
  }

  markdownParser = markdownParser

  hasAsked: boolean = false
  isNotConfirm: boolean = true
  confirmed: boolean = false

  title: string = ''
  body: string = ''
  invalidTitle: boolean = false
  invalidBody: boolean = false
  questionType: string = 'nomal_question'
  materials: File[] = []
  questionForm: UserQuestionForm
  mobile = checkMobile()

  get isLoading(){
    return userQuestionState.isLoading
  }


  @Watch('vModel', {immediate: true})
  reset(){
    this.title = ''
    this.body = ''
    this.hasAsked = false
    this.isNotConfirm = true
    this.confirmed = false
  }

  get user() {
    return userState.user
  }

  changeToConfirm() {
    this.confirmed = true
    this.isNotConfirm = false
  }

  backToForm() {
    this.isNotConfirm = true
    this.confirmed = false
  }

  get currentTime() {
    var today = new Date();
    return `${today.getFullYear()}-${(today.getMonth() + 1)}-${today.getDate()}`;
  }

  async createQuestion() {
    this.invalidTitle = !this.title
    this.invalidBody = !this.body
    if (this.invalidTitle || this.invalidBody) return

    const questionForm = new UserQuestionForm()
    if (this.courseId) {
      questionForm.courseId = this.courseId
    }
    if (this.lessonId) {
      questionForm.lessonId = this.lessonId
    }

    questionForm.title = this.title
    questionForm.body = this.body
    questionForm.questionType = this.questionType
    questionForm.materials = this.materials

    const result = await userQuestionState.create(questionForm)

    this.hasAsked = true
    this.isNotConfirm = true
    this.confirmed = true
    this.isNotConfirm = true
    this.title = ''
    this.body = ''
    this.questionType = 'nomal_question'
    this.materials = []
    this.invalidTitle = false
    this.invalidBody = false
    
    if (this.$route.name !== ROUTER_NAME.MY_COURSE_DETAIL) {
      this.$root.$emit('questionCreated', result)
    }

    setTimeout(() => {
      this.vModel = false
    }, this.mobile ? 1000 : 3000)
  }
}
